<template>
    <div style="background-color:rgb(248, 248, 248);margin:0px 0px;">
        <div class="row align-items-center no-gutters settings-header">
            <div class="col-12">
                <a href="#" @click.prevent="toggleCollapse" class="settings-header" :style="headerStyle">
                    <div v-if="collapsable" style="float:right;"><i class="bi bi-plus" style="font-size:24px;" v-if="isCollapsed"></i><i class="bi bi-dash" style="font-size:24px;" v-else></i></div>

                    <span class="icon" v-html="iconHtml" v-if="icon"></span>

                    <strong>{{title}}</strong>
                </a>
            </div>
        </div> 
        <div style="font-size:16px;border-top:1px solid #ddd;padding-top:5px;" v-if="!isCollapsed">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Settings',
    components: {},
    props: ['location', 'factsheet', 'loaded', 'title', 'icon', 'isCollapsed', 'isPro'],
    data() {
        return {

        }
    },
    created() {
    },
    computed: {
        collapsable: function() {
            return (this.isCollapsed == false) || (this.isCollapsed == true);
        },
        headerStyle: function() {
            if (!this.collapsable) {
                return "pointer-events: none;"
            }
        } ,
        iconHtml: function() {
            if(this.icon) {
                if(this.icon == 'pro') {
                    return "<span style='border: medium; border-radius: 3px; font-size: 14px; color: rgb(255, 255, 255); padding: 1px 3px; margin-top: 2px; margin-left: 2px; margin-right: 3px; background-color: rgb(132, 186, 69);'>Pro</span>"
                } else {
                    return "<i class='bi bi-"+this.icon+"'></i>";
                }
            }
            return "<i class='bi bi-sliders'></i>";
        }       
    },
    mounted() {

    },
    methods: {
        toggleCollapse() {
            if(this.isCollapsed == true) {
                this.isCollapsed = false;
            } else {
                this.isCollapsed = true;
            }

        },      

    }
}
</script>

<style scoped>
    a.settings-header {
        color:#666;
        background-color:#f5f5f5;
        display:block;
        padding:6px 8px;
        font-size:16px;
    }
    a.settings-header:hover {
        background-color:#eeeeee;
    }
    span.icon {
        margin-right:4px;
    }  

</style>